import { useLocation, useNavigate } from 'react-router-dom'
import { Book, Calendar, Home, PlusCircle, Search, ShoppingBasket } from 'lucide-react'
import { useAuthStore } from '@/stores/auth-store'
import { useThemeStore } from '@/stores/theme-store'
import { HeaderAccountControls } from '@/components/layout/header-account-controls'
import { HeaderBrand } from '@/components/layout/header-brand'
import { HeaderPrimaryNav, type HeaderNavigationItem } from '@/components/layout/header-primary-nav'

const navigationItems: HeaderNavigationItem[] = [
  { name: 'Home', href: '/', icon: Home },
  { name: 'Weekmenu', href: '/weekmenu', icon: ShoppingBasket },
  { name: 'Mijn Recepten', href: '/recepten', icon: Book },
  { name: 'Weekplanning', href: '/weekplanning', icon: Calendar },
  { name: 'Zoeken', href: '/zoeken', icon: Search },
  { name: 'Nieuw', href: '/recepten/nieuw', icon: PlusCircle },
]

export function Navigation() {
  const location = useLocation()
  const navigate = useNavigate()
  const { user, logout } = useAuthStore()
  const { theme, toggleTheme } = useThemeStore()

  const handleLogout = () => {
    void logout()
    navigate('/')
  }

  return (
    <nav className="border-b border-gray-200 bg-white">
      <div className="container py-3">
        <div className="flex items-center justify-between gap-4">
          <HeaderBrand />
          <div className="hidden min-w-0 flex-1 md:block">
            <HeaderAccountControls
              user={user}
              theme={theme}
              onToggleTheme={toggleTheme}
              onLogout={handleLogout}
            />
          </div>
        </div>
      </div>

      <HeaderPrimaryNav items={navigationItems} currentPath={location.pathname} />

      <div className="md:hidden">
        <HeaderAccountControls
          user={user}
          theme={theme}
          onToggleTheme={toggleTheme}
          onLogout={handleLogout}
          mobile
        />
      </div>
    </nav>
  )
}
